module.exports = __webpack_public_path__ + "assets/img/picto-pfeil-back.266ee4ad.svg";